<div class="flex items-center mb-5">
  <div class="relative w-full lg:max-w-[435px]">
    <input
      placeholder="Search an equipment..."
      class="w-full !pe-10 input-field focus:outline-0"
    />
    <img
      src="../../../../../../assets/images/icons/ticket-detail/search-icon.svg"
      alt=""
      class="absolute cursor-pointer right-4 top-2.5"
    />
  </div>
</div>


<div class="border border-[#EBEDF3] rounded-md">
  <cdk-accordion class="w-full">
    <cdk-accordion-item *ngFor="let item of items; let i = index" [expanded]="expandedIndex === i">
      <!-- Accordion Header Start -->

      <div class="px-4 py-2.5 border-b border-[#EBEDF3] cursor-pointer {{expandedIndex === i ? 'bg-[#FBFBFC]' : '' }}"
           tabindex="0" role="button"
           [attr.aria-expanded]="expandedIndex === i"
           [attr.aria-controls]="'accordion-body-' + i"
           [attr.id]="'accordion-header-' + i" (click)="toggle(i)">
        <p class="font-semibold text-xs leading-5">Turf Maintenance Equipment</p>
      </div>

      <!-- Accordion Body Start -->
      <div
        [@expandCollapse]="expandedIndex === i ? 'expanded' : 'collapsed'"
        role="region"
        [attr.id]="'accordion-body-' + i"
        [attr.aria-labelledby]="'accordion-header-' + i"
        class="overflow-hidden"
      >
        <div class="border-b border-[#EFF0F5]">
          <div class="grid lg:grid-cols-3 grid-cols-1 gap-1.5 border-b border-[#EBEDF3]">
            <div class="lg:ps-10 px-4 py-2.5">
              <div class="flex items-center gap-3">
                <div class="flex items-center justify-end">
                  <!-- Label for toggle switch -->
                  <div class="relative inline-block w-7 h-4 cursor-pointer">
                    <input id="check-1" type="checkbox" class="sr-only peer" />
                    <!-- Track -->
                    <div
                      class="w-full h-full bg-gray-300 rounded-full peer-checked:bg-[#22973F] transition-colors duration-300">
                    </div>
                    <!-- Knob -->
                    <div
                      class="absolute top-[2.5px] left-[3px] w-[11px] h-[11px] bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-[11px]">
                    </div>
                  </div>
                </div>
                <!-- Label for text to also toggle -->
                <label for="check-1" class="font-medium text-xs leading-5 text-[#60646C] cursor-pointer">
                  Greens mowers
                </label>
              </div>
            </div>
            <div class="lg:ps-10 px-4 py-2.5">
              <div class="flex items-center gap-3">
                <div class="flex items-center justify-end">
                  <!-- Label for toggle switch -->
                  <label class="relative inline-block w-7 h-4 cursor-pointer">
                    <input id="Greens-mowers" type="checkbox" class="sr-only peer" />
                    <!-- Track -->
                    <div
                      class="w-full h-full bg-gray-300 rounded-full peer-checked:bg-[#22973F] transition-colors duration-300">
                    </div>
                    <!-- Knob -->
                    <div
                      class="absolute top-[2.5px] left-[3px] w-[11px] h-[11px] bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-[11px]">
                    </div>
                  </label>
                </div>
                <!-- Label for text to also toggle -->
                <label for="Greens-mowers" class="font-medium text-xs leading-5 text-[#60646C] cursor-pointer">
                  Greens mowers
                </label>
              </div>
            </div>
            <div class="lg:ps-10 px-4 py-2.5">
              <div class="flex items-center gap-3">
                <div class="flex items-center justify-end">
                  <!-- Label for toggle switch -->
                  <label class="relative inline-block w-7 h-4 cursor-pointer">
                    <input id="Greens-mowers" type="checkbox" class="sr-only peer" />
                    <!-- Track -->
                    <div
                      class="w-full h-full bg-gray-300 rounded-full peer-checked:bg-[#22973F] transition-colors duration-300">
                    </div>
                    <!-- Knob -->
                    <div
                      class="absolute top-[2.5px] left-[3px] w-[11px] h-[11px] bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-[11px]">
                    </div>
                  </label>
                </div>

                <!-- Label for text to also toggle -->
                <label for="Greens-mowers" class="font-medium text-xs leading-5 text-[#60646C] cursor-pointer">
                  Greens mowers
                </label>
              </div>
            </div>
          </div>
          <div class="grid lg:grid-cols-3 grid-cols-1 gap-1.5 border-b border-[#EBEDF3]">
            <div class="lg:ps-10 px-4 py-2.5">
              <div class="flex items-center gap-3">
                <div class="flex items-center justify-end">
                  <!-- Label for toggle switch -->
                  <div class="relative inline-block w-7 h-4 cursor-pointer">
                    <input id="check-1" type="checkbox" class="sr-only peer" />

                    <!-- Track -->
                    <div
                      class="w-full h-full bg-gray-300 rounded-full peer-checked:bg-[#22973F] transition-colors duration-300">
                    </div>

                    <!-- Knob -->
                    <div
                      class="absolute top-[2.5px] left-[3px] w-[11px] h-[11px] bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-[11px]">
                    </div>
                  </div>
                </div>

                <!-- Label for text to also toggle -->
                <label for="check-1" class="font-medium text-xs leading-5 text-[#60646C] cursor-pointer">
                  Greens mowers
                </label>
              </div>
            </div>
            <div class="lg:ps-10 px-4 py-2.5">
              <div class="flex items-center gap-3">
                <div class="flex items-center justify-end">
                  <!-- Label for toggle switch -->
                  <label class="relative inline-block w-7 h-4 cursor-pointer">
                    <input id="Greens-mowers" type="checkbox" class="sr-only peer" />

                    <!-- Track -->
                    <div
                      class="w-full h-full bg-gray-300 rounded-full peer-checked:bg-[#22973F] transition-colors duration-300">
                    </div>

                    <!-- Knob -->
                    <div
                      class="absolute top-[2.5px] left-[3px] w-[11px] h-[11px] bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-[11px]">
                    </div>
                  </label>
                </div>

                <!-- Label for text to also toggle -->
                <label for="Greens-mowers" class="font-medium text-xs leading-5 text-[#60646C] cursor-pointer">
                  Greens mowers
                </label>
              </div>
            </div>
            <div class="lg:ps-10 px-4 py-2.5">
              <div class="flex items-center gap-3">
                <div class="flex items-center justify-end">
                  <!-- Label for toggle switch -->
                  <label class="relative inline-block w-7 h-4 cursor-pointer">
                    <input id="Greens-mowers" type="checkbox" class="sr-only peer" />

                    <!-- Track -->
                    <div
                      class="w-full h-full bg-gray-300 rounded-full peer-checked:bg-[#22973F] transition-colors duration-300">
                    </div>

                    <!-- Knob -->
                    <div
                      class="absolute top-[2.5px] left-[3px] w-[11px] h-[11px] bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-[11px]">
                    </div>
                  </label>
                </div>

                <!-- Label for text to also toggle -->
                <label for="Greens-mowers" class="font-medium text-xs leading-5 text-[#60646C] cursor-pointer">
                  Greens mowers
                </label>
              </div>
            </div>
          </div>
          <div class="grid lg:grid-cols-3 grid-cols-1 gap-1.5 border-b border-[#EBEDF3]">
            <div class="lg:ps-10 px-4 py-2.5">
              <div class="flex items-center gap-3">
                <div class="flex items-center justify-end">
                  <!-- Label for toggle switch -->
                  <div class="relative inline-block w-7 h-4 cursor-pointer">
                    <input id="check-1" type="checkbox" class="sr-only peer" />

                    <!-- Track -->
                    <div
                      class="w-full h-full bg-gray-300 rounded-full peer-checked:bg-[#22973F] transition-colors duration-300">
                    </div>

                    <!-- Knob -->
                    <div
                      class="absolute top-[2.5px] left-[3px] w-[11px] h-[11px] bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-[11px]">
                    </div>
                  </div>
                </div>

                <!-- Label for text to also toggle -->
                <label for="check-1" class="font-medium text-xs leading-5 text-[#60646C] cursor-pointer">
                  Greens mowers
                </label>
              </div>
            </div>
            <div class="lg:ps-10 px-4 py-2.5">
              <div class="flex items-center gap-3">
                <div class="flex items-center justify-end">
                  <!-- Label for toggle switch -->
                  <label class="relative inline-block w-7 h-4 cursor-pointer">
                    <input id="Greens-mowers" type="checkbox" class="sr-only peer" />

                    <!-- Track -->
                    <div
                      class="w-full h-full bg-gray-300 rounded-full peer-checked:bg-[#22973F] transition-colors duration-300">
                    </div>

                    <!-- Knob -->
                    <div
                      class="absolute top-[2.5px] left-[3px] w-[11px] h-[11px] bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-[11px]">
                    </div>
                  </label>
                </div>

                <!-- Label for text to also toggle -->
                <label for="Greens-mowers" class="font-medium text-xs leading-5 text-[#60646C] cursor-pointer">
                  Greens mowers
                </label>
              </div>
            </div>
            <div class="lg:ps-10 px-4 py-2.5">
              <div class="flex items-center gap-3">
                <div class="flex items-center justify-end">
                  <!-- Label for toggle switch -->
                  <label class="relative inline-block w-7 h-4 cursor-pointer">
                    <input id="Greens-mowers" type="checkbox" class="sr-only peer" />

                    <!-- Track -->
                    <div
                      class="w-full h-full bg-gray-300 rounded-full peer-checked:bg-[#22973F] transition-colors duration-300">
                    </div>

                    <!-- Knob -->
                    <div
                      class="absolute top-[2.5px] left-[3px] w-[11px] h-[11px] bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-[11px]">
                    </div>
                  </label>
                </div>

                <!-- Label for text to also toggle -->
                <label for="Greens-mowers" class="font-medium text-xs leading-5 text-[#60646C] cursor-pointer">
                  Greens mowers
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </cdk-accordion-item>
  </cdk-accordion>
</div>
